import cn from "classnames";
import styles from "gui/chart/labels.module.css";
import { ChartScale } from "gui/chart/scales";
import { ChartScales } from "gui/chart/scales";
import { ChartSeries } from "gui/chart/series";
import { QueryResultColumn } from "lib/results/types";
import { QueryResultRow } from "lib/results/types";
import { VisualChart } from "lib/visuals/types";
import { accessFloat } from "gui/chart/scales";
import { chartOptionLabels } from "gui/chart/options";
import { scaleAccessor } from "gui/chart/scales";
import { formatNumber } from "lib/numbers/numbers";
import { formatValue } from "gui/chart/format";

export const ChartLabels: React.FC<{
  visual: VisualChart;
  series: ChartSeries;
  scales: ChartScales;
  column: QueryResultColumn;
  y: ChartScale;
  isRightYAxisSeries: boolean;
}> = (props) => {
  if (!chartOptionLabels(props.visual)) {
    return null;
  }

  return (
    <>
      {props.series.rows.map((r, i) => (
        <ChartLabelText
          key={i}
          className={styles.text}
          x={scaleAccessor(props.scales.x, props.series.x)(r)}
          y={scaleAccessor(props.y, props.column)(r) - 10}
        >
          {formatValue(
            props.visual,
            props.series,
            props.column,
            r[props.column.name],
            { isRightYAxisSeries: props.isRightYAxisSeries }
          )}
        </ChartLabelText>
      ))}
    </>
  );
};

export const ChartLabelPie: React.FC<{
  visual: VisualChart;
  column: QueryResultColumn;
  row: QueryResultRow;
  centroid: [number, number];
  total: number;
}> = (props) => {
  if (!chartOptionLabels(props.visual)) {
    return null;
  }

  const percentage = accessFloat(props.column)(props.row) / props.total;
  const text = percentage > 0.05 ? formatNumber(percentage, "0.0%") : "";

  return (
    <ChartLabelText
      className={styles.pie}
      x={props.centroid[0]}
      y={props.centroid[1]}
    >
      {text}
    </ChartLabelText>
  );
};

export const ChartLabelText: React.FC<{
  x: number;
  y: number;
  className?: string;
}> = (props) => {
  return (
    <text
      x={props.x}
      y={props.y}
      textAnchor="middle"
      dominantBaseline="middle"
      className={cn(styles.text, props.className)}
    >
      {props.children}
    </text>
  );
};
